/**
 * Platform technology hub: sticky tab nav + in-page scroll for two articles.
 */
const ROOT_SELECTOR = "#platform-tech-page-root";

export function initPlatformTechHub() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const nav = root.querySelector(".no-platform-tech-hub__nav");
    const tabs = nav?.querySelectorAll(".no-platform-tech-hub__tab");
    const articles = root.querySelectorAll(".no-platform-tech-hub__article[id]");
    if (!tabs?.length || !articles.length) return;

    const setActive = (hash) => {
        tabs.forEach((tab) => {
            const href = tab.getAttribute("href");
            tab.classList.toggle("is-active", href === hash);
        });
    };

    tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
            const href = tab.getAttribute("href");
            if (!href || href.charAt(0) !== "#") return;
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: "smooth", block: "start" });
                setActive(href);
                history.pushState(null, "", href);
            }
        });
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const id = entry.target.id;
                if (id) setActive(`#${id}`);
            });
        },
        {
            root: null,
            rootMargin: "-32% 0px -48% 0px",
            threshold: 0,
        },
    );

    articles.forEach((article) => observer.observe(article));

    const syncFromHash = () => {
        const h = window.location.hash;
        if (h === "#platform-tech-t311" || h === "#platform-tech-hio") {
            setActive(h);
        }
    };

    window.addEventListener("hashchange", syncFromHash);
    syncFromHash();
}
